'use client';

import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { FlexibleHeroBlockProps } from './types';
import { getHeroBackground } from './utils';

type FlexibleHeroBlockSectionProps = Pick<
  FlexibleHeroBlockProps,
  | 'theme'
  | 'backgroundImageDesktop'
  | 'backgroundImageMobile'
  | 'ContentContainer'
> & {
  headingId?: string;
  children: ReactNode;
};

/**
 * Outer `<section>` every hero variant renders in: the CMS background (or the
 * theme fallback), the hero spacing, the heading link for screen readers and
 * the host's content container (page gutters, or the modal's padding).
 */
export const FlexibleHeroBlockSection: FC<FlexibleHeroBlockSectionProps> = ({
  theme,
  backgroundImageDesktop,
  backgroundImageMobile,
  ContentContainer,
  headingId,
  children,
}) => {
  const heroBackground = getHeroBackground(
    theme,
    backgroundImageDesktop,
    backgroundImageMobile,
  );

  return (
    <section
      className={classNames(
        'mhg-alpha-hero-section-spacing w-full overflow-hidden',
        heroBackground.className,
      )}
      style={heroBackground.style}
      aria-labelledby={headingId}
      data-component="flexible-hero-block"
    >
      {ContentContainer ? (
        <ContentContainer>{children}</ContentContainer>
      ) : (
        children
      )}
    </section>
  );
};
